<template>
  <div class="container">
    <div class="display-5 my-5"><span>POLITYKA PRYWATNOŚCI</span></div>
    <p><strong><span>obowiązująca od dnia: <span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[DD.MM.RRRR]</span></span></strong></p>
    <h2><span>1. Informacje ogólne</span></h2>
    <p><span>Niniejsza Polityka Prywatności określa zasady przetwarzania danych osobowych użytkowników serwisu internetowego </span><strong><span><span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[Nazwa Serwisu]</span></span></strong><span>, dostępnego pod adresem </span><strong><span>[</span></strong><a
        href="https://twojadomena.pl"><strong><span>https://twojadomena.pl</span></strong></a><strong><span>]</span></strong><span>.</span></p>
    <p><span>Administrator dokłada należytej staranności, aby dane osobowe były przetwarzane zgodnie z obowiązującymi przepisami prawa, w szczególności z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. (RODO).</span></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>2. Administrator danych</span></h2>
    <p><span>Administratorem danych osobowych jest:</span></p>
    <p><strong><span><span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[Nazwa firmy]</span></span></strong><br><span>Adres: </span><strong><span><span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm"
                                                                                                                                                                                                                                                                                                                                                        style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[Adres]</span></span></strong><br><span>NIP: </span><strong><span><span
        data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[NIP]</span></span></strong><br><span>Adres e-mail: </span><strong><span>[</span></strong><a
        href="mailto:kontakt@domena.pl"><strong><span>kontakt@domena.pl</span></strong></a><strong><span>]</span></strong></p>
    <p><span>W sprawach dotyczących ochrony danych osobowych można kontaktować się pod adresem e-mail:</span></p>
    <p><strong><span>[</span></strong><a href="mailto:kontakt@domena.pl"><strong><span>kontakt@domena.pl</span></strong></a><strong><span>]</span></strong></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>3. Jakie dane są przetwarzane?</span></h2>
    <p><span>Administrator przetwarza wyłącznie dane niezbędne do funkcjonowania Serwisu, w szczególności:</span></p>
    <ul data-spread="false">
      <li><p><span>adres e-mail,</span></p></li>
      <li><p><span>dane związane z utworzonym kontem,</span></p></li>
      <li><p><span>informacje dotyczące dokonanych rezerwacji,</span></p></li>
      <li><p><span>dane techniczne związane z korzystaniem z Serwisu (np. adres IP, informacje o przeglądarce, logi systemowe), jeżeli są automatycznie zapisywane przez serwer.</span></p></li>
    </ul>
    <p><span>Administrator nie przetwarza szczególnych kategorii danych osobowych.</span></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>4. Cele i podstawy przetwarzania danych</span></h2>
    <p><span>Dane osobowe przetwarzane są w następujących celach:</span></p>
    <h3><span>a) Utworzenie i prowadzenie konta użytkownika</span></h3>
    <p><span>Zakres danych:</span></p>
    <ul data-spread="false">
      <li><p><span>adres e-mail.</span></p></li>
    </ul>
    <p><span>Podstawa prawna:</span></p>
    <ul data-spread="false">
      <li><p><span>art. 6 ust. 1 lit. b RODO – wykonanie umowy lub podjęcie działań przed jej zawarciem.</span></p></li>
    </ul>
    <div contenteditable="false">
      <hr>
    </div>
    <h3><span>b) Obsługa rezerwacji</span></h3>
    <p><span>Zakres danych:</span></p>
    <ul data-spread="false">
      <li><p><span>adres e-mail,</span></p></li>
      <li><p><span>informacje dotyczące rezerwacji.</span></p></li>
    </ul>
    <p><span>Podstawa prawna:</span></p>
    <ul data-spread="false">
      <li><p><span>art. 6 ust. 1 lit. b RODO.</span></p></li>
    </ul>
    <div contenteditable="false">
      <hr>
    </div>
    <h3><span>c) Zapewnienie bezpieczeństwa Serwisu</span></h3>
    <p><span>Obejmuje m.in. wykrywanie nadużyć, prowadzenie logów systemowych oraz zabezpieczenie infrastruktury.</span></p>
    <p><span>Podstawa prawna:</span></p>
    <ul data-spread="false">
      <li><p><span>art. 6 ust. 1 lit. f RODO – prawnie uzasadniony interes Administratora.</span></p></li>
    </ul>
    <div contenteditable="false">
      <hr>
    </div>
    <h3><span>d) Dochodzenie lub obrona roszczeń</span></h3>
    <p><span>Podstawa prawna:</span></p>
    <ul data-spread="false">
      <li><p><span>art. 6 ust. 1 lit. f RODO.</span></p></li>
    </ul>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>5. Marketing</span></h2>
    <p><span>Administrator </span><strong><span>nie wykorzystuje adresów e-mail do przesyłania informacji marketingowych ani newslettera</span></strong><span>.</span></p>
    <p><span>W przypadku uruchomienia takich usług w przyszłości będą one realizowane wyłącznie zgodnie z obowiązującymi przepisami prawa oraz – jeśli będzie to wymagane – po uzyskaniu odpowiedniej zgody Użytkownika.</span></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>6. Odbiorcy danych</span></h2>
    <p><span>Dane mogą zostać udostępnione wyłącznie podmiotom współpracującym z Administratorem w zakresie niezbędnym do świadczenia usług, takim jak:</span></p>
    <ul data-spread="false">
      <li><p><span>dostawca hostingu,</span></p></li>
      <li><p><span>dostawca poczty elektronicznej,</span></p></li>
      <li><p><span>dostawcy usług informatycznych utrzymujących Serwis.</span></p></li>
    </ul>
    <p><span>Podmioty te przetwarzają dane wyłącznie na podstawie odpowiednich umów i zgodnie z poleceniami Administratora.</span></p>
    <p><span>Administrator nie sprzedaje danych osobowych.</span></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>7. Przekazywanie danych poza Europejski Obszar Gospodarczy</span></h2>
    <p><span>Co do zasady dane osobowe przetwarzane są na terenie Europejskiego Obszaru Gospodarczego.</span></p>
    <p><span>Jeżeli Administrator korzysta z usług dostawców mających siedzibę poza EOG (np. usług chmurowych lub pocztowych), dane będą przekazywane wyłącznie zgodnie z wymaganiami RODO, w szczególności na podstawie odpowiednich zabezpieczeń przewidzianych w przepisach.</span></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>8. Okres przechowywania danych</span></h2>
    <p><span>Dane osobowe przechowywane są:</span></p>
    <ul data-spread="false">
      <li><p><span>przez okres posiadania konta użytkownika,</span></p></li>
      <li><p><span>przez okres niezbędny do obsługi rezerwacji,</span></p></li>
      <li><p><span>przez okres wymagany przepisami prawa, jeżeli taki obowiązek istnieje,</span></p></li>
      <li><p><span>do czasu przedawnienia ewentualnych roszczeń.</span></p></li>
    </ul>
    <p><span>Po usunięciu konta dane mogą być przechowywane wyłącznie w zakresie niezbędnym do realizacji obowiązków prawnych lub ochrony praw Administratora.</span></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>9. Prawa użytkownika</span></h2>
    <p><span>Każdej osobie, której dane dotyczą, przysługuje prawo do:</span></p>
    <ul data-spread="false">
      <li><p><span>dostępu do swoich danych,</span></p></li>
      <li><p><span>sprostowania danych,</span></p></li>
      <li><p><span>usunięcia danych („prawo do bycia zapomnianym”), jeżeli przepisy na to pozwalają,</span></p></li>
      <li><p><span>ograniczenia przetwarzania,</span></p></li>
      <li><p><span>przenoszenia danych,</span></p></li>
      <li><p><span>wniesienia sprzeciwu wobec przetwarzania opartego na uzasadnionym interesie Administratora,</span></p></li>
      <li><p><span>wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych.</span></p></li>
    </ul>
    <p><span>Żądania dotyczące danych osobowych można kierować na adres:</span></p>
    <p><strong><span>[</span></strong><a href="mailto:kontakt@domena.pl"><strong><span>kontakt@domena.pl</span></strong></a><strong><span>]</span></strong></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>10. Dobrowolność podania danych</span></h2>
    <p><span>Podanie adresu e-mail jest dobrowolne, jednak niezbędne do utworzenia konta oraz korzystania z funkcji rezerwacji.</span></p>
    <p><span>Brak podania wymaganych danych uniemożliwia korzystanie z tych usług.</span></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>11. Zautomatyzowane podejmowanie decyzji</span></h2>
    <p><span>Administrator nie podejmuje wobec użytkowników decyzji opartych wyłącznie na zautomatyzowanym przetwarzaniu danych, w tym profilowaniu, które wywoływałyby skutki prawne lub w podobny sposób istotnie wpływały na użytkowników.</span></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>12. Pliki cookies</span></h2>
    <p><span>Serwis wykorzystuje pliki cookies w celu zapewnienia prawidłowego działania strony.</span></p>
    <p><span>Cookies mogą być wykorzystywane między innymi do:</span></p>
    <ul data-spread="false">
      <li><p><span>utrzymania sesji użytkownika po zalogowaniu,</span></p></li>
      <li><p><span>zapewnienia bezpieczeństwa,</span></p></li>
      <li><p><span>zapamiętania wybranych ustawień interfejsu.</span></p></li>
    </ul>
    <p><span>Jeżeli Serwis korzysta z narzędzi analitycznych (np. Google Analytics, Plausible, Matomo) lub innych usług wykorzystujących cookies, informacje o tym należy uzupełnić w tym miejscu.</span></p>
    <p><span>Użytkownik może zarządzać plikami cookies za pomocą ustawień swojej przeglądarki internetowej.</span></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>13. Bezpieczeństwo danych</span></h2>
    <p><span>Administrator stosuje odpowiednie środki techniczne i organizacyjne mające na celu ochronę danych osobowych przed ich utratą, zniszczeniem, nieuprawnionym ujawnieniem lub dostępem osób nieuprawnionych.</span></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>14. Zmiany Polityki Prywatności</span></h2>
    <p><span>Administrator może aktualizować niniejszą Politykę Prywatności w przypadku zmian przepisów prawa, zmian technologicznych lub zmian funkcjonalności Serwisu.</span></p>
    <p><span>Aktualna wersja Polityki Prywatności jest zawsze dostępna na stronie internetowej Serwisu.</span></p>
    <div contenteditable="false">
      <hr>
    </div>
    <h2><span>15. Dane kontaktowe</span></h2>
    <p><span>W sprawach związanych z przetwarzaniem danych osobowych prosimy o kontakt:</span></p>
    <p><strong><span><span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[Nazwa firmy]</span></span></strong><br><span>E-mail: </span><strong><span>[</span></strong><a
        href="mailto:kontakt@domena.pl"><strong><span>kontakt@domena.pl</span></strong></a><strong><span>]</span></strong><br><span>Adres: </span><strong><span><span data-placeholder-token="true" class="text-token-text-primary cursor-text rounded-sm" style="background-color: color-mix(in srgb, var(--theme-user-selection-bg, var(--selection)) 30%, transparent); padding-top: 4px; padding-bottom: 4px;">[Adres]</span></span></strong></p></div>
</template>

<script>
export default {
  name: "PrivacyPolicyPage"
}
</script>

<style scoped>

</style>